import { CloseIcon } from '@chakra-ui/icons'
import { Box, Text } from '@chakra-ui/react'
import { formatPrice } from '../../../../utils/formatPrice'

export function ToastSuccess({ params, toast }) {
  return (
    <Box
      color="white"
      w="600px"
      h="200px"
      p={3}
      bg="#95c620"
      display="flex"
      justifyContent="center"
      alignItems="center"
      transition="all 0.2s"
      transform="translateY(150%)"
      fontFamily={'Roboto, sans-serif'}
      flexDirection={'column'}
      position={'relative'}
    >
      <CloseIcon
        onClick={toast.closeAll}
        position={'absolute'}
        right={'10px'}
        top={'10px'}
        cursor={'pointer'}
      />
      <Text
        as={'h1'}
        fontSize={'1.5rem'}
        fontWeight={'bold'}
        justifySelf={'flex-start'}
      >
        Dados de entrega salvos com sucesso!
      </Text>
      <Text as={'p'} m={0}>
        você escolheu a transportadora{' '}
        <span style={{ fontWeight: 'bold' }}>{params?.nome}</span>
      </Text>
      <Text as={'p'} m={0}>
        com o valor de{' '}
        <span style={{ fontWeight: 'bold' }}>
          R$ {formatPrice(params?.preco)}
        </span>
      </Text>{' '}
      <Text as={'p'} m={0}>
        e prazo de entrega de{' '}
        <span style={{ fontWeight: 'bold' }}>{params?.prazo?.max} dias</span>
      </Text>
    </Box>
  )
}
